import { render, staticRenderFns } from "./litihengfei.vue?vue&type=template&id=072df4b6&scoped=true&"
import script from "./litihengfei.vue?vue&type=script&lang=js&"
export * from "./litihengfei.vue?vue&type=script&lang=js&"
import style0 from "./litihengfei.vue?vue&type=style&index=0&id=072df4b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072df4b6",
  null
  
)

export default component.exports